import { defineComponent as _defineComponent } from 'vue'
import Irmao from '@/../common/types/Irmao'
import { useQuery } from '@tanstack/vue-query';
import CertificadoService from '@/services/CertificadoService';
import { obterDescricaoCompletaDoEvento } from '@/shareds/sharedsEvento';
import { Certificado, StatusDoCertificado } from 'common/types/certificado/Certificado';
import { formatarData } from '@/../common/shareds/formatadores';
import { obterCorDoStatusDoCertificado } from '@/shareds/sharedCertificado';
import dayjs from 'dayjs';


export default /*#__PURE__*/_defineComponent({
  __name: 'AbaDeCertificadosDoIrmao',
  props: {
    irmao: null
  },
  setup(__props: any) {

const { irmao } = __props as { irmao: Irmao };



const { data: paginas, error, isLoading } = useQuery({
    queryKey: ['certificados', irmao._id],
    queryFn: () => CertificadoService.findPage({
        idIrmao: irmao._id,
    }),
})

const DESCRICAO_STATUS_EVENTO: Record<StatusDoCertificado, string> = {
    aprovado: 'Aprovado',
    rejeitado: 'Rejeitado',
    solicitado: 'Solicitado'
} as const

function obterDescricaoStatusCertificado(certificado: Certificado) {
    if (certificado.status === 'solicitado') {
        return "Aguardando aprovação"
    }
    return `${DESCRICAO_STATUS_EVENTO[certificado.status]} ${dayjs().to(dayjs(certificado.verificadoEm))}` 
}


return { __sfc: true,paginas, error, isLoading, DESCRICAO_STATUS_EVENTO, obterDescricaoStatusCertificado, obterDescricaoCompletaDoEvento, formatarData, obterCorDoStatusDoCertificado }
}

})